import { GridCellProps } from "@progress/kendo-react-grid";
import { Card, CardBody } from "@progress/kendo-react-layout";
import React, { useRef, useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import style from "./style.module.css";
import { ICON_NAMES } from "utils/constant";
import { TextButton } from "ui/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import { PurchaseOverview } from "interface/sales";
import {
	purchaseOverviewDetailGridItems,
	BuyerOverviewGridColumnItem,
} from "component/pages/purchaseOverview/utils/GridColumns";
import {
	getPurchaseOverviewApi,
	getPurchaseOverviewLinesApi,
	PurchaseOverviewFilter,
} from "api/sales";

import { useUserOrganizationsStore } from "store";
import GridCustomPage from "../../../ui/grid/GridPage";
import CustomDetailedPage from "../../../ui/grid/DetailPage";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GrideDateFormatter } from "ui/Date";

function PurchaseOverviewCard({
	isMobileView = false,
}: {
	isMobileView?: boolean;
	buyerLedgerAccountNumber?: string;
}) {
	const [gridData, setGridData] = useState<PurchaseOverview[]>([]);

	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [businessNumber, setbusinessNumber] = useState<string | null>(null);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const { defaultOrg } = useUserOrganizationsStore();

	const [filterOptions, setFilterOptions] = useState<PurchaseOverviewFilter>({
		take: 3,
		skip: 0,
		fromDate: null,
		toDate: null,
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const openEdit = (prop: GridCellProps) => {
		// navigate(`/`);
		// window.open(
		// 	`/${PageTypePath.LandingNoteForm}/${prop.dataItem.noteNumber}/0`
		// );
	};

	const handleLinesPdfDown = (props: GridCellProps, id: string) => {
		window.open(`/${PageTypePath.Pdf}/${props.dataItem.reportGuid}`, "_blank");
		return;
	};

	useEffect(() => {
		if (defaultOrg !== null && defaultOrg.businessNumber !== businessNumber) {
			setbusinessNumber(defaultOrg.businessNumber);
			setForceUpdate((prev) => !prev);
		}
	}, [defaultOrg]);

	useEffect(() => {
		if (!isMobileView) {
			return;
		}

		getPurchaseOverviewApi({
			buyerLedgerAccountNumber: defaultOrg?.ledgerAccountNumber as any,
			take: 3,
			skip: 0,
			fromDate: null,
			toDate: null,
		})
			.then((response) => {
				setGridData(response.data || []);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [isMobileView, defaultOrg?.ledgerAccountNumber]);


	async function getPurchaseOverviews() {
		return getPurchaseOverviewApi({
			buyerLedgerAccountNumber: defaultOrg?.ledgerAccountNumber as any,
			take: 3,
			skip: 0,
			fromDate: null,
			toDate: null,
		})
			.then((response) => {
				return response;
			})
			.catch((err) => {
				console.log(err);
			});
	}

	return (
		<div>
			<Card
				//className={style.CardItem}
				className={"home-card-item"}
			>
				<CardBody>
					<div className={`${styles.BoxHeadingMedium} ${style.CardBodyHeader}`}>
						<div>{t("LastInDocumentOverview")}</div>
						<div>
							<TextButton
								text={t("DocumentOverview")}
								onClick={() => navigate(`/${PageTypePath.PurchaseOverview}`)}
								iconName={ICON_NAMES.Arrow}
							/>
						</div>
					</div>
					<div>
						{isMobileView ? (
							<div>
								{gridData.map((item, index) => {
									const source = (item as any).source;

									return (
									<div
										key={`${item.salesId}-${index}`}
										className="home-mobile-list-item"
									>
										<div className="home-mobile-list-item-main">
											<div className="home-mobile-list-item-value">
												{item.buyerName || "-"}
											</div>
											<div className="home-mobile-list-item-label">
												<GrideDateFormatter
													date={item.salesDate}
													formatType="dd.MM.yyyy"
													noTd={true}
												/>
											</div>
										</div>
										<div className="home-mobile-list-item-secondary">
											{item.salesType || "-"}
										</div>
										{source === 0 && (
											<div className="home-mobile-list-item-actions">
												<button
													type="button"
													className="home-mobile-icon-btn"
													onClick={() => openEdit({ dataItem: item } as GridCellProps)}
												>
													<img src={`/icon/${ICON_NAMES.Edit}.svg`} alt={t("Edit")} />
												</button>
											</div>
										)}
									</div>
									);
								})}
							</div>
						) : (
							<GridCustomPage
								dataKey="salesId"
								gridColumns={BuyerOverviewGridColumnItem()}
								filter={filterOptions}
								exportGridAsPDFRef={pdfRef}
								lastColWidth="130px"
								gridName = "Dokumentoversiktgrid"
								detailPage={(prop) => (
									<CustomDetailedPage
										grids={purchaseOverviewDetailGridItems}
										dataApi={() =>
											getPurchaseOverviewLinesApi({
												salesId: prop.dataItem.salesId,
												source: prop.dataItem.source,
											})
										}
										lastColBtns={[
											{
												notEqualToValue: 1,
												conditionField: "source",
												iconName: ICON_NAMES.Download,
												onclick: (props) =>
													handleLinesPdfDown(props, prop.dataItem.salesId),
											},
										]}
									/>
								)}
								lastColBtns={[
									{
										iconName: ICON_NAMES.Edit,
										conditionField: "source",
										showConditionValue: 0,
										onclick: openEdit,
									},
								]}
								exportGridAsExcelRef={excelRef}
								apiMethod={getPurchaseOverviews}
								forceUpdate={forceUpdate}
								showLoader={false}
								gridHeight={270}
							/>
						)}
					</div>
				</CardBody>
			</Card>
		</div>
	);
}

export default PurchaseOverviewCard;
